import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import audio from "../../assets/SOS_Sound.mp3";
import SOS from "../../assets/images/SOS_image.png";

const Notify = ({ payload, onClose }: any) => {
    const [modalShow, setModalShow] = useState(true);
    const [music] = useState(new Audio(audio));
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`/view-service-request/${payload?.data?.uuid}`);
        music.pause();
        music.currentTime = 0;
        onClose();
    };

    const handleClose = () => {
        setModalShow(false);
        music.pause();
        music.currentTime = 0;
        onClose();
    };

    useEffect(() => {
        if (!modalShow) return;

        music.loop = true;

        const playAudio = async () => {
            try {
                await music.play();
            } catch (error) {
                console.warn("🔕 Audio autoplay blocked or not supported", error);
            }
        };

        playAudio();

        return () => {
            music.pause();
            music.currentTime = 0;
        };
    }, [modalShow]);

    return (
        <Modal show={modalShow} centered>
            <Modal.Header>
                <Modal.Title>{payload?.notification?.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-18">
                <div className="text-center">
                    <img src={SOS} width={60} className="mb-3" alt="SOS" />
                    <p className="text-secondary-dark">
                        {payload?.notification?.body}
                    </p>
                    {payload?.data?.uuid && (
                        <p className="cursor-pointer font-bold font-12" onClick={handleNavigate}>
                            <u style={{ color: "blue" }}>Check Details</u>
                        </p>
                    )}
                    <div className="px-3 py-lg-1 py-3 text-end mobile-sticky-bottom text-center">
                        <Button className="me-3" id="yes" onClick={handleClose}>
                            OK
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default Notify;
